export class AppSettings {
  activityIdleTimeout: number;
  activityInactivityTimeout: number;
  maintenance: boolean;
  siteMessage: string;
  siteMessageStyle: string;
  siteMessageExpiration: number;
}
